module.exports = __webpack_public_path__ + "static/media/_p_918_2022-06-30_e.2d1f75a0.jpeg";